import { login, signup } from "/providers/auth-api"

const credentialsSignin = async ({ formData, apiSource, applyLoginResponse }) => {
  return handler({ fn: login, formData, apiSource, applyLoginResponse })
}

const credentialsSignup = async ({ formData, apiSource, applyLoginResponse }) => {
  return handler({ fn: signup, formData, apiSource, applyLoginResponse })
}

export { credentialsSignin, credentialsSignup }


const handler = async ({ fn, formData, apiSource, applyLoginResponse }) => {

  const email = formData.get('email')
  const password = formData.get('password')
  const name = formData.get('name')

  let loginResponse = await fn({apiSource, email, password, name})

  if (loginResponse.authenticated) {
    await applyLoginResponse(loginResponse, { preserveSelectedClient: false })
    return { authenticated: true }
  } else {
    return { type: 'CredentialsSignin', error: loginResponse.error }
  }
}
